module.exports = __webpack_public_path__ + "static/media/psychiatry.52aaf017.svg";